<template>
  <div class="article-block--components row-flex" :class="reverse? 'reverse': ''" @click="handleClick">
    <div class="cover-img-box" >
      <img v-if="info.CoverImage" :src="emptyImg" alt="" srcset="" v-lazy='info.CoverImage'>
      <img v-else :src="emptyImg" alt="" srcset="" >
      <span class="video-tips" v-if='info.Type == 2'>
        <van-icon name="play" />
        <span>{{info.VideoDuration}}</span>
      </span>
    </div>
    <div class="row-flex-eq article-info">
      <div v-if="isMarked" class="title mult-ellipsis" v-html="MarkeTitle(info.Title)"></div>
      <div v-else class="title mult-ellipsis">{{info.Title}}</div>
      <div class="msg row-flex-between">
        <div>
          <span class="is-top-icon" v-if=" !notShowTopIcon && info.Top">置顶</span>
          <span class="author ellipsis text-lighter text-small">{{info.Author}}</span>
        </div>
        <span v-if="!reverse">
          <span class="text-gray text-small" v-if='info.PublishDate'>{{info.PublishDate | time-parse}}</span>
          <span class="text-gray text-small" v-if='info.DisplayTime'>{{info.DisplayTime | time-parse}}</span>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'articleBlock',
  props: {
    info: {
      required: true,
      default: () => {
        return {
          Title: '',
          CoverImage: '',
          Top: false,
          Author: '',
          DisplayTime: '',
          Link: ''
        }
      }
    },
    reverse: {
      type: Boolean,
      default: false
    },
    canClick: {
      type: Boolean,
      default: true,
    },
    searchKey: {
      type: String,
      default: ''
    },
    isMarked: {
      type: Boolean,
      default: false,
    },
    // 只有个人中心页有置顶
    notShowTopIcon: {
      type: Boolean,
      default: false,
    },
    isAd: {
      type: Boolean,
      default: false,
    }
  },
  
  data() {
    return {
      emptyImg: process.env.VUE_APP_EMPTY_IMG
    }
  },
  methods: {
    handleClick() {
      if (!this.canClick) return
      if (this.isAd) {
        window.location.href = this.info.Link
      } else {
        this.$router.push({ name: 'detail', params: { id: this.info.Id }, query: {id: this.info.Id} })
      }
    },
    MarkeTitle(title) {
      return this.$mdUtils.MarkeStr(title, this.searchKey)
    },
  }
}
</script>

<style scoped lang="scss">
.article-block--components {
  padding-top: 14px;

  &.reverse {
    flex-direction: row-reverse;
    .cover-img-box {
      margin-right: 0;
    }
    .author {
      color: $gray-deep;
    }
    .article-info {
      margin-right: 14px;
    }
  }
  .cover-img-box {
    position: relative;
    margin-right: 14px;
    width: 83px;
    height: 59px;

    img {
      width: inherit;
      height: inherit;
    }
  }
  .is-top-icon {
    margin-right: 10px;
  }
  .title {
    line-height: 20px;
    color: $text-main;
    font-size: $font-size-normal;
  }
  .msg {
    padding: 4px 0;
  }
  .mult-ellipsis {
    height: 38px;
    width: 238px;
  }
  .article-info {
    padding-bottom: 14px;
    border-bottom: 1px solid $gray;
  }
  .author {
    position: relative;
    top: 3px;
    display: inline-block;
    max-width: 90px;
    line-height: 18px;
    color: $gray-deep-more;
  }
  .icon-tupian {
    font-size: 59px;
  }
}
</style>
